<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="addAbsentReportDialog" max-width="900">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-3"
                    >New Absent Report</v-card-title
                >
                <v-layout row>
                    <v-layout column xs6 class="pr-3" style="min-width: 50%">
                        <!-- <v-select
                            class="mx-1 mb-0"
                            label="Driver / Bus"
                            v-model="newAbsentReport.driver_bus"
                            :items="
                                newAbsentReport.driver_busList.map(
                                    (b) => b.displayName,
                                )
                            "
                            ref="driver_bus"
                            clearable
                            :rules="[rules.required]"
                            @change="driverBusChanged"
                        ></v-select> -->

                        <v-autocomplete
                            class="mx-1 mb-0"
                            label="Driver / Bus"
                            v-model="newAbsentReport.driver_bus"
                            :items="
                                newAbsentReport.driver_busList.map(
                                    (b) => b.displayName,
                                )
                            "
                            ref="driver_bus"
                            clearable
                            :rules="[rules.required]"
                            @change="driverBusChanged"
                        ></v-autocomplete>

                        <v-menu
                            v-model="newAbsentReport.datePickerMenu"
                            :close-on-content-click="false"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="newAbsentReport.dates"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="newAbsentReport.dates"
                                multiple
                                @change="datesChanged"
                            ></v-date-picker>
                        </v-menu>

                        <v-select
                            v-model="newAbsentReport.absentReason"
                            label="Reason"
                            :items="reasons.map((r) => r.reason)"
                            ref="absentReason"
                            :rules="[rules.required]"
                        ></v-select>

                        <v-text-field
                            v-model="newAbsentReport.note"
                            label="Note"
                        ></v-text-field>

                        <v-text-field
                            v-model="newAbsentReport.calendarNote"
                            label="Calendar Note"
                        ></v-text-field>

                        <v-select
                            v-model="newAbsentReport.geoUpdated"
                            label="GEO Updated"
                            :items="['YES', 'NO', 'N/A']"
                        ></v-select>

                        <v-select
                            v-model="newAbsentReport.notifiedDriver"
                            label="Notified Driver"
                            :items="['YES', 'NO', 'N/A']"
                        ></v-select>

                        <!-- <div class="mt-3 mb-2 font-weight-medium">
                            Sub Driver
                        </div>
                        <v-btn-toggle
                            v-model="subDriverListFilter"
                            @change="subDriverListFilterChanged"
                        >
                            <v-btn flat value="all" class="pa-2">
                                <span>All</span>
                            </v-btn>
                            <v-btn flat value="not_occupied" class="pa-2">
                                <span>Not Occupied</span>
                            </v-btn>
                        </v-btn-toggle>

                        <v-autocomplete
                            v-model="selectedSubDriver"
                            :disabled="isUpdatingSubDriversList"
                            :items="subDriversDisplayList"
                            hide-details
                            box
                            chips
                            color="success"
                            class="mt-3"
                            label="Select"
                            item-text="displayName"
                            item-value="id"
                            clearable
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    :selected="data.selected"
                                    close
                                    class="chip--select-multi"
                                    @input="removeSubDriver(data.item)"
                                >
                                    {{ data.item.displayName }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content
                                        v-text="data.item"
                                    ></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title
                                            v-html="data.item.displayName"
                                        ></v-list-tile-title>
                                        <v-list-tile-sub-title
                                            v-html="data.item.group"
                                        ></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete> -->
                    </v-layout>

                    <v-layout column xs6 class="pl-2" style="min-width: 50%">
                        <v-layout
                            class="ml-1 pl-1 mb-2"
                            row
                            style="max-height: fit-content;"
                        >
                            <v-select
                                class="pt-3"
                                v-model="season"
                                label="Season"
                                :items="seasons"
                                hide-details
                                style="max-width: 200px;"
                                @change="
                                    driverBusChanged(newAbsentReport.driver_bus)
                                "
                            ></v-select>
                            <v-select
                                class="ml-2 pt-3"
                                v-model="regID"
                                label="Term"
                                :items="terms"
                                hide-details
                                style="max-width: 150px;"
                                @change="
                                    driverBusChanged(newAbsentReport.driver_bus)
                                "
                            ></v-select>
                        </v-layout>

                        <div class="mt-2 mb-2 ml-1 pl-1 font-weight-medium">
                            Routes
                        </div>

                        <v-progress-linear
                            v-if="newAbsentReport.loadingRoutes"
                            :indeterminate="true"
                            color="success"
                        ></v-progress-linear>
                        <div
                            v-if="
                                !newAbsentReport.loadingRoutes &&
                                    !newAbsentReport.routes.length
                            "
                            class="mt-0 ml-1 pl-1 font-weight-light"
                        >
                            {{
                                !newAbsentReport.driver_bus ||
                                !newAbsentReport.dates.length
                                    ? "Please Select Driver & Dates"
                                    : "No Routes"
                            }}
                        </div>

                        <v-checkbox
                            v-if="newAbsentReport.routes.length"
                            class="mx-1 my-0 py-0"
                            style="max-height: 30px;"
                            @change="newAbsentReportSelectAllChanged($event)"
                            label="Select All"
                            color="success"
                            v-model="newAbsentReport.selectAllRoutes"
                            hide-details
                        ></v-checkbox>

                        <v-layout
                            row
                            style="max-height: fit-content;"
                            v-if="
                                newAbsentReport.routes.length &&
                                    getRouteGroups().length > 1
                            "
                        >
                            <v-checkbox
                                v-for="group in getRouteGroups()"
                                class="mx-1 mb-3 py-0"
                                style="max-height: 45px;"
                                :ref="`new_${group}`"
                                v-model="newAbsentReport.routeGroups[group]"
                                @change="
                                    newAbsentReportSelectGroupChanged(
                                        $event,
                                        group,
                                    )
                                "
                                :label="`Select By ${group}`"
                                color="success"
                                hide-details
                            ></v-checkbox>
                        </v-layout>

                        <div
                            style="overflow-y: auto; max-height: 300px;"
                            class="mt-0"
                            v-if="newAbsentReport.routes.length"
                        >
                            <template
                                v-for="(route,
                                index) in newAbsentReport.routes.map(
                                    (r) => r.displayName,
                                )"
                            >
                                <v-checkbox
                                    class="mx-1 my-0"
                                    :key="`route-checkbox-${route}`"
                                    v-model="newAbsentReport.selectedRoutes"
                                    :value="route"
                                    :label="route"
                                    color="success"
                                ></v-checkbox>
                            </template>
                        </div>
                    </v-layout>
                </v-layout>

                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addAbsentReportDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewAbsentReport()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="updateSubDriverDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-2 pt-0"
                    >Update Sub Driver</v-card-title
                >
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; max-height: 300px">
                        <div v-for="(absent, index) in selected">
                            <div class="font-weight-regular">
                                {{ absent.date | date }}
                            </div>
                            <div class="font-weight-medium">
                                Driver - Bus:
                                {{
                                    absent.driver +
                                        " (" +
                                        absent.busNumber +
                                        ")"
                                }}
                            </div>
                            <div class="caption">
                                {{
                                    absent.timeStart +
                                        " - " +
                                        absent.buildings +
                                        " - " +
                                        (absent.grades ? absent.grades : "")
                                }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>

                    <v-select
                        class="my-3 pb-1"
                        v-model="geoUpdated"
                        label="GEO Updated"
                        :items="['YES', 'NO', 'N/A']"
                        hide-details
                    ></v-select>

                    <v-select
                        class="mb-2"
                        v-model="notifiedDriver"
                        label="Notified Driver"
                        :items="['YES', 'NO', 'N/A']"
                        hide-details
                    ></v-select>

                    <v-btn-toggle
                        class="mt-3"
                        v-model="subDriverListFilter"
                        @change="subDriverListFilterChanged"
                    >
                        <v-btn flat value="all" class="pa-2">
                            <span>All</span>
                        </v-btn>
                        <v-btn flat value="not_occupied" class="pa-2">
                            <span>Not Occupied</span>
                        </v-btn>
                    </v-btn-toggle>

                    <v-autocomplete
                        v-model="selectedSubDriver"
                        :disabled="isUpdatingSubDriversList"
                        :items="subDriversDisplayList"
                        hide-details
                        box
                        chips
                        color="success"
                        class="mt-3"
                        label="Select"
                        item-text="displayName"
                        item-value="id"
                        clearable
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                :selected="data.selected"
                                close
                                class="chip--select-multi"
                                @input="removeSubDriver(data.item)"
                            >
                                {{ data.item.displayName }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                                <v-list-tile-content
                                    v-text="data.item"
                                ></v-list-tile-content>
                            </template>
                            <template v-else>
                                <v-list-tile-content>
                                    <v-list-tile-title
                                        v-html="data.item.displayName"
                                    ></v-list-tile-title>
                                    <v-list-tile-sub-title
                                        v-html="data.item.group"
                                    ></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateSubDriverDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveSubDriver"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Absent Reports</v-card-title
                >
                <div class="font-weight-regular">
                    The {{ selected.length }} selected will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteReports"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="detachFromRoutesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Detach From Routes</v-card-title
                >
                <div class="font-weight-regular">
                    The {{ selected.length }} selected absents will be detach
                    from routes
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="detachFromRoutesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="detachFromRoutes"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="updateAbsentReportDialog" max-width="900">
            <update-absent
                :absent="rowClicked"
                :reload="reload"
                :closeAbsentReportDialog="closeAbsentReportDialog"
            ></update-absent>
        </v-dialog>

        <v-dialog persistent v-model="reasonsDialog" max-width="600">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Absent Reasons</v-card-title
                >

                <v-layout row class="ml-3">
                    <v-btn small color="success" class="mb-3" @click="addReason"
                        >Add Reason</v-btn
                    >
                    <v-btn
                        small
                        color="success"
                        class="mb-3 ml-2"
                        v-if="reasons.some((l) => l.selected)"
                        @click="deleteReasons"
                        :loading="processing"
                        >Delete Reasons</v-btn
                    >
                </v-layout>

                <div v-for="(reason, index) in newReasons">
                    <v-layout row class="pa-0 ml-3 mb-0">
                        <v-text-field
                            class="mx-2"
                            v-model="reason.reason"
                            label="Reason"
                        ></v-text-field>

                        <v-btn @click="addReason" flat icon color="success">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                        <v-btn
                            @click="removeReason(index)"
                            flat
                            icon
                            color="#f55a4e"
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </div>
                <v-btn
                    color="success"
                    small
                    class="ml-3 mt-0 mb-4"
                    :loading="processing"
                    @click="saveNewReasons"
                    v-if="newReasons.length"
                    >Save</v-btn
                >

                <v-divider class="pb-0 pt-1"></v-divider>
                <div style="height: 450px; overflow-y: auto;">
                    <div v-for="(reason, index) in reasons">
                        <v-layout column class="pa-0 ml-3 mb-0">
                            <v-layout row>
                                <v-checkbox
                                    class="width-50 pt-2 my-0"
                                    hide-details
                                    v-model="reason.selected"
                                    v-if="!reason.editing"
                                    color="success"
                                ></v-checkbox>

                                <div class="pt-2" v-if="!reason.editing">
                                    {{ reason.reason }}
                                </div>
                                <v-text-field
                                    v-if="reason.editing"
                                    class="mx-2"
                                    v-model="reason.reason"
                                    label="Reason"
                                    ref="reason"
                                    :rules="[rules.required]"
                                ></v-text-field>

                                <v-btn
                                    small
                                    color="default"
                                    dark
                                    @click="rollbackReason(reason)"
                                    class="mx-2"
                                    v-if="reason.editing"
                                    style="height: 28px;"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    small
                                    color="success"
                                    @click="saveReason(reason)"
                                    class="mx-2"
                                    :loading="processing"
                                    v-if="reason.editing"
                                    style="height: 28px;"
                                    >Save</v-btn
                                >

                                <v-btn
                                    @click="editReason(reason)"
                                    v-if="!reason.editing"
                                    flat
                                    icon
                                    class="my-0 pb-1 pt-0"
                                    color="success"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-layout>
                        <v-divider
                            class="pb-0 pt-1"
                            v-if="index + 1 < reasons.length"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="reasonsDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import { toISOLocal, groupBy } from "../../utils/helpers.js";
import updateAbsent from "./UpdateAbsent.vue";

export default {
    components: {
        updateAbsent,
    },
    data: () => ({
        title: "Absent Reports",

        actions: [],

        updateDriverDialog: false,
        addAbsentReportDialog: false,

        newAbsentReport: {
            datePickerMenu: false,
            dates: [],
            //route: "",
            driver_bus: "",
            note: "",
            calendarNote: "",
            absentReason: "",
            geoUpdated: "",
            notifiedDriver: "",
            routes: [],
            driver_busList: [],
            selectedRoutes: [],
            loadingRoutes: false,
        },

        updateAbsentReportDialog: false,
        rowClicked: {
            driver: "",
            busNumber: "",
            timeStart: "",
            buildings: "",
            grades: "",
            datePickerMenu: false,
            date: "",
        },

        updateAbsentReport: {
            selectedSubDriver: "",
            isUpdatingSubDriversList: false,
            subDriversDisplayList: [],
            subDrivers: [],
            subDriverListFilter: "all",
        },

        processing: false,
        deleteDialog: false,
        updateSubDriverDialog: false,
        detachFromRoutesDialog: false,
        subDrivers: [],
        subDriversDisplayList: [],
        selectedSubDriver: "",
        isUpdatingSubDriversList: false,
        subDriverListFilter: "all",
        deleting: false,
        selected: [],
        files: [],
        url: "",
        employeeList: [],
        employees: [],
        employees2: [],
        loadEmployeeSearch: null,
        loadClickedEmployeeSearch: null,
        loadClickedBusesSearch: null,
        selectedEmployee: "",
        clickedEmployee: "",

        clickedBuses: "",
        buses: [],
        busList: [],

        driverBuses: [],

        reasonsDialog: false,
        newReasons: [],
        reasons: [],

        geoUpdated: "",
        notifiedDriver: "",
        terms: [],
        regID: "",
        seasons: [],
        season: "",

        rules: {
            required: (value) => !!value || "Required.",
            busNumberRequired: (value, bus) => {
                return !bus.dateFrom || !bus.dateFrom || !!value || "Required.";
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        columns: [
            {
                label: "Driver",
                field: "driver",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Number",
                field: "busNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Route Description",
                field: "description",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Term",
                field: "term",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Time Start",
                field: "timeStart",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Sub Driver",
                field: "subDriver",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Absent Reason",
                field: "absentReason",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "GEO Updated",
                field: "geoUpdated",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notified Driver",
                field: "notifiedDriver",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Calendar Note",
                field: "calendarNote",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Buildings",
                field: "buildings",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grades",
                field: "grades",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Week Days",
                field: "weekDays",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Color",
                field: "color",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notes",
                field: "notes",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered By",
                field: "enteredBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {
        loadEmployeeSearch(value) {
            if (!value) return;
            if (!this.employeeList.length) return;

            this.employees = this.employeeList.filter((b) =>
                b.displayName.toUpperCase().includes(value.toUpperCase()),
            );
        },
        loadClickedEmployeeSearch(value) {
            if (!value) return;
            if (!this.employeeList.length) return;

            this.employees2 = this.employeeList.filter((b) =>
                b.displayName.toUpperCase().includes(value.toUpperCase()),
            );
        },
        loadClickedBusesSearch(value) {
            if (!value) return;
            if (!this.busList.length) return;

            this.buses = this.busList.filter((b) =>
                b.busNumber.toUpperCase().includes(value.toUpperCase()),
            );
        },
        isUpdating(val) {
            if (val) {
                setTimeout(() => (this.isUpdating = false), 3000);
            }
        },
        "newAbsentReport.dates": {
            handler(newVal) {
                this.datesChanged(newVal);
            },
            deep: true,
        },
    },
    mounted() {},
    beforeDestroy() {},
    async created() {
        this.loadDriverBusList();
        this.loadSubDriverList();
        this.loadEmployees();
        this.loadBuses();
        this.loadReasons();

        this.loadSeason();
        this.loadSeasons();
        this.loadTerms();
        this.loadRegID();
    },
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Actions",
                isMenu: true,
                items: [
                    {
                        value: "report-absent",
                        text: "Report Absent",
                    },
                    {
                        value: "delete-absent-reports",
                        text: "Delete Absent Reports",
                        showOnSelection: true,
                    },
                    {
                        value: "update-sub-drivers",
                        text: "Update Sub Drivers",
                        showOnSelection: true,
                    },
                    {
                        value: "detach-from-routes",
                        text: "Detach From Routes",
                        showOnSelection: true,
                    },
                    {
                        value: "absent-reasons",
                        text: "Absent Reasons",
                    },
                ],
                value: "Actions",
                name: "Actions",
                action: this.openActionModal,
            });

            this.url = "driverAbsent";
        },
        openActionModal(option) {
            // const selected = this.$refs.grid.getSelectedRowsData();

            // if (option != "add-route" && !selected.length) {
            //     return this.$notify({
            //         group: "notification",
            //         text: "No Routes Selected",
            //         type: "error",
            //     });
            // }

            switch (option) {
                case "absent-reasons":
                    return this.openReasonsDialog();
                case "delete-absent-reports":
                    return this.openDeleteAbsentReports();
                case "update-sub-drivers":
                    return this.openUpdateSubDrivers();
                case "detach-from-routes":
                    return this.openDetachFromRoutes();
                case "report-absent":
                    return this.addAbsentReport();
            }
        },
        openReasonsDialog() {
            this.reasonsDialog = true;
        },
        async loadReasons() {
            this.reasons = await this.$http.get(
                "api/driverAbsent/GetDriverAbsentReasons",
            );
        },
        addReason() {
            this.newReasons.push({
                reasons: "",
            });
        },
        removeReason(index) {
            this.newReasons.splice(index, 1);
        },
        editReason(reason) {
            reason.original = reason.reason;
            reason.editing = true;

            this.$forceUpdate();
        },
        rollbackReason(reason) {
            reason.reason = reason.original;
            reason.editing = false;

            this.$forceUpdate();
        },
        async saveReason(reason) {
            const editingList = this.reasons.filter((r) => r.editing);
            const element = editingList.find((r) => r.id == reason.id);
            const index = editingList.indexOf(element);

            if (!this.$refs.reason[index].validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/driverAbsent/updateReason", reason);

                reason.original = "";
                reason.editing = false;

                this.$notify({
                    group: "notification",
                    text: "Reason Updated",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async saveNewReasons() {
            try {
                if (this.newReasons.some((b) => !b.reason)) {
                    return this.$notify({
                        text: "Reason can't be empty",
                        group: "notification",
                        type: "error",
                    });
                }

                this.processing = true;

                await this.$http.post(
                    "api/driverAbsent/SaveAbsentReportReasons",
                    this.newReasons.map((r) => ({
                        reason: r.reason,
                    })),
                );

                this.loadReasons();
                this.newReasons = [];
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteReasons() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/driverAbsent/DeleteAbsentReportReasons",
                    this.reasons
                        .filter((d) => d.selected)
                        .map((reason) => reason.id),
                );

                this.loadReasons();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async loadDriverBusList() {
            const response = await this.$http.get("api/route/getDriverBusList");

            this.newAbsentReport.driver_busList = response
                .map((driverBus) => {
                    driverBus.displayName =
                        (driverBus.nameH ? driverBus.nameH : driverBus.name) +
                        " - " +
                        driverBus.busNumber;

                    return driverBus;
                })
                .sort((a, b) => a.busNumber - b.busNumber);
        },
        async loadSubDriverList() {
            this.selectedSubDriver = "";

            // if (this.absent.date.includes("Z")) {
            //     this.absent.date = toISOLocal(
            //         new Date(this.absent.date),
            //     ).substr(0, 10);
            // } else {
            //     this.absent.date = new Date(this.absent.date)
            //         .toISOString()
            //         .substr(0, 10);
            // }

            const response = await this.$http.post(
                "api/driverAbsent/getSubDrivers",
                [],
            );

            this.subDrivers = response
                .map((driver) => {
                    driver.displayName =
                        (driver.nameH ? driver.nameH : driver.name) +
                        " (" +
                        driver.busNumber +
                        ")";

                    driver.group = driver.isOccupied
                        ? "Occupied"
                        : "Not Occupied";

                    if (driver.position == "Substitute")
                        driver.group += ` <span class='substitute-option'>Substitute</span>`;

                    return driver;
                })
                .sort((a, b) => {
                    if (a.group < b.group) {
                        return -1;
                    }
                    if (a.group > b.group) {
                        return 1;
                    }
                    return 0;
                });

            this.subDrivers = this.subDrivers.reduce((acc, curr) => {
                const { group } = curr;

                let groupHeader = group;

                groupHeader = groupHeader.replace(
                    ` <span class='substitute-option'>Substitute</span>`,
                    ``,
                );

                const foundIndex = acc.findIndex(
                    (item) => item.group === groupHeader,
                );
                // if group is not yet added
                if (foundIndex === -1) {
                    // add divider after full list of Not Occupied
                    if (groupHeader === "Occupied") {
                        acc.push({ divider: true });
                    }
                    acc.push({
                        header: groupHeader.toUpperCase(),
                    });
                }
                acc.push(curr);
                return acc;
            }, []);

            this.subDriversDisplayList = this.subDrivers;
        },
        async loadEmployees() {
            const response = await this.$http.get(
                "api/drivers/GetBusesDriverEmployees",
            );

            this.employeeList = response.map((employee) => {
                employee.displayName =
                    employee.employeeID +
                    " - " +
                    (employee.teacherH ? employee.teacherH : employee.teacher);

                return employee;
            });
        },
        async loadBuses() {
            const response = await this.$http.get("api/drivers/GetBuses");

            this.busList = response;
        },
        async loadTerms() {
            const terms = await this.$http.get("api/allStudents/getRegTerms");

            this.terms = terms;
        },
        async loadRegID() {
            const regID = await this.$http.get("api/allStudents/getRegID");

            this.regID = regID;
        },
        async loadSeasons() {
            const seasons = await this.$http.get("api/route/getRouteSeasons");

            this.seasons = seasons.map((s) => s.season);
        },
        async loadSeason() {
            const season = localStorage.getItem("route-season");

            this.season = season ? season : this.seasons[0];
        },
        async datesChanged(value) {
            this.loadRoutesForDriver();
        },
        async driverBusChanged(value) {
            this.loadRoutesForDriver();
        },
        async loadRoutesForDriver() {
            this.newAbsentReport.selectAllRoutes = false;
            this.newAbsentReport.routeGroups = {};
            this.newAbsentReport.selectedRoutes = [];

            if (
                !this.newAbsentReport.driver_bus ||
                !this.newAbsentReport.dates.length
            )
                return;

            this.newAbsentReport.loadingRoutes = true;

            try {
                const driver = this.newAbsentReport.driver_busList.find(
                    (d) => d.displayName == this.newAbsentReport.driver_bus,
                );

                const response = await this.$http.post(
                    "api/driverAbsent/getRoutesForDriver?",
                    {
                        driverID: driver.id,
                        regID: this.regID,
                        season: this.season,
                        dates: this.newAbsentReport.dates,
                    },
                );

                this.newAbsentReport.routes = response.map((route) => {
                    route.displayName =
                        route.timeStart +
                        " - " +
                        route.routeIdentifier +
                        " - " +
                        route.groupBy;

                    return route;
                });

                this.getRouteGroups().forEach((group) => {
                    this.newAbsentReport.routeGroups[group] = false;
                });

                this.newAbsentReport.loadingRoutes = false;
            } catch (e) {
                this.newAbsentReport.loadingRoutes = false;
            }
        },
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        validateNewReport() {
            const validations = [
                this.$refs.driver_bus.validate(true),
                this.$refs.absentReason.validate(true),
            ];

            return validations.every(Boolean);
        },
        routeSelected(event, route) {
            console.log(event, route);
        },
        getRouteGroups() {
            if (!this.newAbsentReport.routes.length) return [];

            const group = groupBy(this.newAbsentReport.routes, "groupBy");

            return Object.keys(group);
        },
        newAbsentReportSelectAllChanged(value) {
            if (value) {
                this.newAbsentReport.selectedRoutes = this.newAbsentReport.routes
                    .filter((r) => !["FAM", "PPM"].includes(r.groupBy))
                    .map((r) => r.displayName);

                this.getRouteGroups().forEach((g) => {
                    this.newAbsentReport.routeGroups[g] = false;
                });
            } else {
                this.newAbsentReport.selectedRoutes = [];
            }
        },
        newAbsentReportSelectGroupChanged(value, group) {
            if (value) {
                const groupRoutes = this.newAbsentReport.routes
                    .filter((r) => r.groupBy == group)
                    .map((r) => r.displayName);

                groupRoutes.forEach((groupRoute) => {
                    if (
                        this.newAbsentReport.selectedRoutes.includes(groupRoute)
                    );

                    this.newAbsentReport.selectedRoutes.push(groupRoute);
                });

                // this.getRouteGroups().forEach((g) => {
                //     if (g !== group) {
                //         this.newAbsentReport.routeGroups[g] = false;
                //     }
                // });
                // this.newAbsentReport.selectAllRoutes = false;
            } else {
                this.newAbsentReport.selectedRoutes = this.newAbsentReport.selectedRoutes.filter(
                    (selectedRoute) => {
                        const filteredRoutes = this.newAbsentReport.routes
                            .filter((r) => r.groupBy == group)
                            .map((r) => r.displayName);

                        return !filteredRoutes.some((r) => r == selectedRoute);
                    },
                );
            }

            //Trying to update other group checkboxes to be unchecked
            // this.getRouteGroups()
            //     .filter((g) => g != group)
            //     .forEach((group) => {
            //         this.$refs["new_" + group][0].val = false;
            //         console.log(this.$refs["new_" + group][0].val);
            //     });
        },
        getDayOfWeek(date) {
            let dayOfWeek = new Date(date).getDay() + 1;

            if (dayOfWeek == 7) {
                dayOfWeek = 0;
            }

            return isNaN(dayOfWeek)
                ? null
                : [
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                  ][dayOfWeek];
        },
        async saveNewAbsentReport() {
            if (!this.validateNewReport()) return;

            if (!this.newAbsentReport.dates.length) {
                return this.$notify({
                    text: "Date is required",
                    group: "notification",
                    type: "error",
                });
            }

            // if (!this.newAbsentReport.selectedRoutes.length) {
            //     return this.$notify({
            //         text: "Route is required",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            const driver = this.newAbsentReport.driver_busList.find(
                (d) => d.displayName == this.newAbsentReport.driver_bus,
            );

            const data = this.newAbsentReport.dates
                .map((date) => {
                    if (!this.newAbsentReport.selectedRoutes.length) {
                        return [
                            {
                                driver_Bus_ID: driver.id,
                                date: date,
                                enteredBy: this.$store.state.authentication
                                    .user,
                                note: this.newAbsentReport.note,
                                calendarNote: this.newAbsentReport.calendarNote,
                                absentReason: this.newAbsentReport.absentReason,
                                geoUpdated: this.newAbsentReport.geoUpdated,
                                notifiedDriver: this.newAbsentReport
                                    .notifiedDriver,
                                absentReasonID: this.getReasonID(
                                    this.newAbsentReport.absentReason,
                                ),
                            },
                        ];
                    }

                    return this.newAbsentReport.selectedRoutes
                        .filter((selectedRoute) => {
                            const route = this.newAbsentReport.routes.find(
                                (d) => d.displayName == selectedRoute,
                            );
                            return route.weekDays.includes(
                                this.getDayOfWeek(date),
                            );
                        })
                        .map((selectedRoute) => {
                            const route = this.newAbsentReport.routes.find(
                                (d) => d.displayName == selectedRoute,
                            );

                            return {
                                driver_Bus_ID: driver.id,
                                route_ID: route.id,
                                date: date,
                                enteredBy: this.$store.state.authentication
                                    .user,
                                note: this.newAbsentReport.note,
                                calendarNote: this.newAbsentReport.calendarNote,
                                absentReason: this.newAbsentReport.absentReason,
                                geoUpdated: this.newAbsentReport.geoUpdated,
                                notifiedDriver: this.newAbsentReport
                                    .notifiedDriver,

                                absentReasonID: this.getReasonID(
                                    this.newAbsentReport.absentReason,
                                ),
                            };
                        });
                })
                .flat();

            if (!data || !data.length) {
                return this.$notify({
                    text: "Route selected does not run on selected date/s",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/driverAbsent/save", data);

                this.processing = false;
                this.addAbsentReportDialog = false;

                this.newAbsentReport.driver_bus = "";
                this.newAbsentReport.absentReason = "";
                this.newAbsentReport.note = "";
                this.newAbsentReport.dates = [];
                this.newAbsentReport.routes = [];
                this.newAbsentReport.selectedRoutes = [];

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        getReasonID(reason) {
            const data = this.reasons.find((r) => r.reason == reason);

            return data ? data.id : null;
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.updateAbsentReportDialog = true;
        },
        closeAbsentReportDialog() {
            this.updateAbsentReportDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        addAbsentReport() {
            this.newAbsentReport.dates = [];
            this.newAbsentReport.driver_bus = "";
            this.newAbsentReport.route = "";
            this.newAbsentReport.routes = [];
            this.newAbsentReport.selectedRoutes = [];

            this.addAbsentReportDialog = true;
        },
        openDeleteAbsentReports() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteDialog = true;
        },
        openDetachFromRoutes() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.detachFromRoutesDialog = true;
        },
        async openUpdateSubDrivers() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            const absentIDs = this.selected.map((d) => d.id);

            const response = await this.$http.post(
                "api/driverAbsent/getSubDrivers",
                absentIDs,
            );

            this.subDrivers = response
                .map((driver) => {
                    driver.displayName =
                        (driver.nameH ? driver.nameH : driver.name) +
                        " (" +
                        driver.busNumber +
                        ")";

                    // driver.group = driver.isOccupied
                    //     ? "Occupied"
                    //     : "Not Occupied";
                    driver.group = "";

                    if (driver.position == "Substitute")
                        driver.group += ` <span class='substitute-option'>Substitute</span>`;

                    return driver;
                })
                .sort((a, b) => {
                    if (a.group < b.group) {
                        return -1;
                    }
                    if (a.group > b.group) {
                        return 1;
                    }
                    return 0;
                });

            this.subDrivers = this.subDrivers.reduce((acc, curr) => {
                const { group } = curr;

                let groupHeader = group;

                groupHeader = groupHeader.replace(
                    ` <span class='substitute-option'>Substitute</span>`,
                    ``,
                );

                const foundIndex = acc.findIndex(
                    (item) => item.group === groupHeader,
                );
                // if group is not yet added
                if (foundIndex === -1) {
                    // add divider after full list of Not Occupied
                    if (groupHeader === "Occupied") {
                        acc.push({ divider: true });
                    }
                    acc.push({ header: groupHeader.toUpperCase() });
                }
                acc.push(curr);
                return acc;
            }, []);

            this.subDriversDisplayList = this.subDrivers;

            this.updateSubDriverDialog = true;
        },
        subDriverListFilterChanged(value) {
            if (this.updateAbsentReportDialog) {
                this.updateAbsentReport.subDriversDisplayList =
                    value == "all"
                        ? this.updateAbsentReport.subDrivers
                        : this.updateAbsentReport.subDrivers.filter(
                              (s) => s.group == "Not Occupied",
                          );

                return;
            }

            this.subDriversDisplayList =
                value == "all"
                    ? this.subDrivers
                    : this.subDrivers.filter((s) => s.group == "Not Occupied");
        },
        removeSubDriver(item) {
            this.selectedSubDriver = "";

            // if (this.updateAbsentReportDialog) {
            //     this.updateAbsentReport.selectedSubDriver = "";
            // } else {
            //     this.selectedSubDriver = "";
            // }
        },
        async saveSubDriver() {
            try {
                this.processing = true;

                const subDriver = this.subDrivers.find(
                    (sd) => sd.id == this.selectedSubDriver,
                );

                const data = this.selected.map((absent) => {
                    absent.subDriver_Bus_ID = subDriver ? subDriver.id : null;
                    absent.notifiedDriver = this.notifiedDriver;
                    absent.geoUpdated = this.geoUpdated;

                    return absent;
                });

                await this.$http.post("api/driverAbsent/save", data);

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.notifiedDriver = "";
                this.geoUpdated = "";

                this.$refs.grid.reloadGrid();

                this.updateSubDriverDialog = false;
                this.selectedSubDriver = "";
                this.processing = false;
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        validate() {
            const validations = [];

            this.$refs.busNumber.map((busNumber) => {
                validations.push(busNumber.validate(true));
            });

            return validations.every(Boolean);
        },
        async deleteReports() {
            try {
                const ids = this.updateAbsentReportDialog
                    ? [this.rowClicked.id]
                    : this.selected.map((s) => s.id);

                this.processing = true;

                await this.$http.post("api/driverAbsent/delete", ids);

                this.processing = false;
                this.deleteDialog = false;
                this.updateAbsentReportDialog = false;

                this.$notify({
                    group: "notification",
                    text: this.updateAbsentReportDialog
                        ? "Absent Report Deleted"
                        : ids.length + " Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async detachFromRoutes() {
            try {
                const ids = this.selected.map((s) => s.id);

                this.processing = true;

                await this.$http.post("api/driverAbsent/detachFromRoute", ids);

                this.processing = false;
                this.detachFromRoutesDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Absent Reports Updated",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveAbsentReport() {
            if (!this.rowClicked.date) {
                return this.$notify({
                    text: "Date is required",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const subDriver = this.updateAbsentReport.subDrivers.find(
                    (sd) => sd.id == this.updateAbsentReport.selectedSubDriver,
                );

                await this.$http.post("api/driverAbsent/save", [
                    {
                        id: this.rowClicked.id,
                        driver_Bus_ID: this.rowClicked.driver_Bus_ID,
                        route_ID: this.rowClicked.route_ID,
                        date: this.rowClicked.date,
                        subDriver_Bus_ID: subDriver ? subDriver.id : null,
                    },
                ]);

                this.processing = false;
                this.updateAbsentReportDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
.substitute-option {
    font-size: 12px;
    background-color: purple;
    color: #fff;
    width: fit-content;
    padding: 3px;
    margin-bottom: 2px;
    border-radius: 5px;
}
</style>
